module.exports = __webpack_public_path__ + "img/login-right.5a240d8b.png";